import { motion } from 'framer-motion';
import { VOYAGE } from './data';

// VOYAGE — a single sample charter, presented as a horizontal scroll storyboard.
// Distinctive: numbered station markers along a horizontal "sea line".
export default function Voyage({ setPage }) {
  return (
    <div className="bg-[#0A1F2E] text-[#E8DDC7]">
      <section className="pt-32 pb-12 max-w-[1440px] mx-auto px-8 lg:px-14 border-b border-[#E8DDC7]/10">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#B68F4E] mb-4">— Chapter 03 / Sample Voyage</p>
        <div className="grid lg:grid-cols-[1.4fr_1fr] gap-10 items-end">
          <h1 className="font-serif text-[52px] lg:text-[110px] leading-[0.88] tracking-[-0.025em]">Seven days, <span className="italic text-[#B68F4E]">Tropez to Olbia</span>.</h1>
          <div className="text-sm lg:text-base text-[#E8DDC7]/65 leading-[1.65] max-w-md space-y-3">
            <p>An itinerary we have run nine times since 2019, from Saint-Tropez to Olbia along the Corsican spine.</p>
            <p className="text-[#E8DDC7]/50">Aboard <span className="text-[#B68F4E]">Avalon I — Aurora</span>. June or September.</p>
          </div>
        </div>
      </section>

      {/* Horizontal scroll storyboard with sea line */}
      <section className="py-20 overflow-hidden">
        <div className="relative">
          <div className="absolute left-8 right-8 lg:left-14 lg:right-14 top-[80px] h-px bg-[#B68F4E]/30" />
          <div className="overflow-x-auto pb-12 [scrollbar-width:thin]">
            <div className="flex gap-8 px-8 lg:px-14 w-max">
              {VOYAGE.map((v, i) => (
                <motion.div key={v.day} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.06 }}
                  className="w-[320px] lg:w-[380px] flex-shrink-0">
                  <div className="relative h-[80px] flex items-center justify-center mb-6">
                    <div className="w-3 h-3 rounded-full bg-[#B68F4E] z-10" />
                    <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 font-mono text-[9px] tracking-[0.3em] uppercase text-[#B68F4E]/70 whitespace-nowrap">{v.t}</div>
                  </div>
                  <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#B68F4E]">{v.day}</p>
                  <h3 className="font-serif text-3xl lg:text-4xl leading-tight mt-1">{v.port}</h3>
                  <p className="text-sm text-[#E8DDC7]/65 leading-[1.7] mt-4" dangerouslySetInnerHTML={{ __html: v.n }} />
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Block quote — long-form */}
      <section className="border-y border-[#E8DDC7]/10 bg-[#06151E]">
        <div className="max-w-[900px] mx-auto px-8 lg:px-14 py-24">
          <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#B68F4E] mb-6">— On itineraries</p>
          <p className="font-serif text-2xl lg:text-4xl leading-[1.4] italic text-[#E8DDC7]/95">
            &ldquo;A great itinerary is half written by the wind. We arrive at Calvi at first light because Captain Adrien knows the meltemi falls off at four. The rest of the morning is yours.&rdquo;
          </p>
          <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-[#E8DDC7]/45 mt-10">From the bureau notebook · Voyage 47, July 2024</p>
        </div>
      </section>

      <section className="py-24 max-w-[1100px] mx-auto px-8 lg:px-14 text-center">
        <p className="font-serif text-3xl lg:text-5xl leading-tight">Every voyage is bespoke.<br /><span className="italic text-[#B68F4E]">This one was simply ours.</span></p>
        <button onClick={() => setPage('charter')} className="mt-10 inline-flex items-center gap-3 bg-[#B68F4E] text-[#0A1F2E] px-9 py-4 font-mono text-[10px] tracking-[0.32em] uppercase hover:bg-[#E8DDC7] transition-colors">Plan yours →</button>
      </section>
    </div>
  );
}
